import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-maintenance',
    templateUrl: './maintenance.component.html',
    styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

    links = [
        {
            link: 'recurrences',
            label: 'admin.toolMaintenancePlans.tabs.recurrences'
        },
        {
            link: 'plans',
            label: 'admin.toolMaintenancePlans.tabs.plans'
        },
        {
            link: 'activities',
            label: 'admin.toolMaintenancePlans.tabs.activities'
        },
    ];

    constructor() {
    }

    ngOnInit() {
    }

}
